import React, { useEffect, useState } from 'react'
import { Search } from 'lucide-react'
import SearchInput from '../../../components/ui/inputs/SearchInput'
import SearchSelect from '../../../components/ui/selects/SearchSelect'
import { camelizeKeys } from '../../../utils/camelizeKeys'

const MyClientFilters = ({ filters, onChange }) => {
  const handleInputChange = (e) => {
    onChange({ ...filters, [e.target.name]: e.target.value })
  }

  const [walletProfileOptions, setWalletProfileOptions] = useState([])

  useEffect(() => {
    fetch('/app/shared/form_options')
      .then(res => res.json())
      .then(data => {
        const camelData = camelizeKeys(data)
  
        const walletOptions = camelData.walletProfileOptions.map(w => ({ label: w.label, value: w.value }))
  
        setWalletProfileOptions(walletOptions)
      })
      .catch(err => console.error('Erro ao carregar opções do formulário', err))
  }, [])

  return (
    <div className="flex flex-wrap gap-2 items-center font-jost text-sm">
      <div className="w-custom500">
        <SearchInput
          name="search"
          placeholder="Pesquisar cliente..."
          value={filters.search}
          onChange={handleInputChange}
        />
      </div>

      <div className="w-44">
        <SearchSelect
          name="status"
          value={filters.status}
          onChange={handleInputChange}
          placeholder="Status"
          options={[
            { label: 'Ativo', value: 'active' },
            { label: 'Inativo', value: 'inactive' }
          ]}
        />
      </div>

      <div className="w-60">
        <SearchSelect
          name="walletProfile"
          value={filters.walletProfile}
          onChange={handleInputChange}
          placeholder="Perfil da Carteira BTG"
          options={walletProfileOptions}
        />
      </div>
    </div>
  )
}

export default MyClientFilters
